var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonicaProfilOrganizacijeIstaknutiProjekti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5,.cls-6{fill:none;}.cls-1,.cls-9{stroke:#6e5dd8;}.cls-1,.cls-5,.cls-6,.cls-9{stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{fill:#fa7268;}.cls-3{fill:#231f20;}.cls-4{fill:#6e5dd8;}.cls-5{stroke:#000;stroke-linecap:round;}.cls-6{stroke:#fff;}.cls-7{fill:#aa6276;}.cls-8{fill:#159497;}.cls-9{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.83,124.34C106,48.9,232.94,16.52,348.12,40.62c27.23,5.7,54.61,14.81,74.95,32.66s32.16,46.07,23.27,70.8c-7.39,20.57-27,35-46.71,46.51-85.53,50.2-189.19,70-270.95,125.44-18.79,12.73-37.52,29.55-39.23,51.18-2,25.88,22.42,48.31,49.22,55.06s55.18,1.7,82.39-3.38l163.05-30.44c22.07-4.12,45.58-8.15,66.57-.55s36.76,31.68,26,50.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "250 21.84 273.4 94.39 337.97 53.86 309.26 124.48 384.77 134.93 317.39 170.57 368.52 227.12 293.98 211.11 296.81 287.29 250 227.12 203.19 287.29 206.02 211.11 131.48 227.12 182.61 170.57 115.23 134.93 190.74 124.48 162.03 53.86 226.6 94.39 250 21.84"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 98.86,
    cy: 266.12,
    rx: 33.01,
    ry: 34.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.4,240.89a32.06,32.06,0,0,0-22.54-9.33c-18.23,0-33,15.47-33,34.56a35.36,35.36,0,0,0,8.79,23.48C89.32,279,98.51,260.76,96.85,242.1A30.5,30.5,0,0,0,121.4,240.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.17,471.61a340.14,340.14,0,0,0-24.32-112c-7.51-18.53-17.75-37.35-34.31-45.58-19.4-9.64-43.1-1.61-58.63,14.62s-24.09,39.21-29.6,62.24C34.86,413.73,32,448,31.8,471.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.79,
    cy: 264.48,
    rx: 2.2,
    ry: 2.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.2,
    cy: 258.2,
    rx: 2.2,
    ry: 2.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.41,269.32A5.07,5.07,0,0,1,116,272.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.14,452.67c4.91,1.32,9.16,2.65,14.26,3s10.43-.23,14.84-2.59,7.74-6.65,7.81-11.3a10.31,10.31,0,0,0-8.72-10c2.13-1.36,1.7-4.6-.25-6.18s-4.75-1.89-7.35-1.89a44.31,44.31,0,0,0-20.59,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.36,408c-.78-.91-1.53-1.85-2.26-2.81-9.63,11.14-17.43,24-21.62,38.26a69,69,0,0,0,14.62,8.22c14.94,6.11,34.4,6.66,49.67,1.53V426.89A54.81,54.81,0,0,1,79.36,408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.26,364A60.28,60.28,0,0,0,79.36,408a54.81,54.81,0,0,0,40.42,18.93v26.27c-15.28,5.13-34.74,4.58-49.68-1.53a72.27,72.27,0,0,1-35.7-32.35"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 55.48,
    cy: 244.02,
    r: 26.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M271.81,251.32a47.25,47.25,0,0,0,.4,11.5c1,6.17,7.2,12,7.2,12l23.43-4.61s-.12-12.72,0-17.6-.27-14.41-2.06-18.38-9.33-11.71-13.69-15.08-8.14-8-9.53-6-1.58,7.17,0,9.75a16.45,16.45,0,0,1,1.85,3.57s-7.06,3.07-10.94,9.6-4.65,10-2.32,13.88A3.7,3.7,0,0,0,271.81,251.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.45,242.39s-5-9.32-6.75-11.31-3.77-3.31-5.61-1.53,1.84,11.83,1.84,11.83a16,16,0,0,0-5.56,8.56,12.9,12.9,0,0,0,1.19,9.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M378.25,248.92a5.82,5.82,0,0,1,9.51-3.59,33.2,33.2,0,1,1-6.59,9.58A5.83,5.83,0,0,1,378.25,248.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.8,300.49a53.7,53.7,0,0,0,.46-8.29,47.29,47.29,0,0,0-2.41-13,6,6,0,1,0-4.5-10.44c-.37-.72-.73-1.43-1.12-2.16-5.19-9.63-10.61-19.08-8.84-30.43,0,0-1.3-6.77,7-11.93s15.54,4.48,15.54,4.48,10.55-6.89,17.67,0S450.19,241,450.19,241s10.33.66,12.91,11.05-6.2,18.1-6.2,18.1,5.69,4.16,3.62,12.94a16.07,16.07,0,0,1-9.3,11.37,12,12,0,0,1-6.61,13.43C435.72,312.58,420.8,300.49,420.8,300.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350,371a8.6,8.6,0,0,0-7.12-9.14c-19.56-3.47-66.07-13.33-66.07-87a209,209,0,0,1,28.73-5.53c-.8.1,10,39.25,12.07,42.6,2.2,3.62,5.1,7.07,9.06,8.55,4.29,1.6,9.06.65,13.54-.32,37-8,76.19-23.29,107.16,7.68a73.87,73.87,0,0,1,22,42.18,106.84,106.84,0,0,1,.84,20.15,110.17,110.17,0,0,1-4.39,28.31s-.78,27.59-7.47,40.09-32.77,18-52.56,16.43-27.26-3.94-27.26-3.94S346.69,414.49,350,371Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "368.75 440.12 368.75 415.93 316.35 415.93 316.35 483.39 368.75 483.39 368.75 440.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M395.66,436s-2.55-1.93-9.28-3.53-17.63-1.92-17.63-1.92v9.61s-12-.48-18.59,0-9,2.41-9.29,6.9,3.36,17.3,9.93,20.19,26.77-1.12,33.5-3.37a149.34,149.34,0,0,0,14.42-5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M467.68,414.74c-2.82,9.06-10.18,21.4-17.46,27.48-16,13.38-35.11,16.19-51.5,15.71l-3.27-23.48a36,36,0,0,0,11.47-5.37,58.65,58.65,0,0,0,23.3-66.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 236.4,
    cy: 358.82,
    r: 6.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.56,
    cy: 252.09,
    r: 2.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381,269.12a5.2,5.2,0,0,0,7.27,1.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.44,
    y: 146.15,
    width: 16.82,
    height: 16.82,
    transform: "translate(131.7 309.13) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "436.15 52.84 430.43 42.92 441.88 42.92 436.15 52.84"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonicaProfilOrganizacijeIstaknutiProjekti);
export default __webpack_public_path__ + "static/media/Ikonica-Profil_organizacije-istaknuti_projekti.5463cb27f751b99413810918337f61d0.svg";
export { ForwardRef as ReactComponent };